module.exports = __webpack_public_path__ + "img/symbol.07587427.svg";